import React, { useEffect } from 'react';
import Box from '@material-ui/core/Box';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { useKeyboard } from 'src/hooks/useKeyboard';
import SimpleKeyboard, { Layout } from './SimpleKeyboard';

const keyboardBoxHeight = '455px';

const KeyboardContainer: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const {
    isKeyboardVisible,
    keyboardRef,
    layout = Layout.Qwerty
  } = useSelector((state: RootState) => state.keyboard);
  const {
    keyboardProps: { handleChange }
  } = useKeyboard();
  useEffect(() => {
    if (isKeyboardVisible === false) {
      handleChange('');
    }
  }, [isKeyboardVisible, handleChange]);
  return (
    <Box display={'flex'} flexDirection={'column'} height={'100vh'}>
      {children}
      
      <Box
        height={keyboardBoxHeight}
        zIndex={9999}
        hidden={!isKeyboardVisible}
      >
        <SimpleKeyboard
          keyboardRef={keyboardRef}
          onChange={(val) => {
            handleChange(val);
          }}
          layout={layout}
        />
      </Box>
    </Box>
  );
};

export default KeyboardContainer;
